import { BrButton, BrLoading } from '@govbr-ds/react-components';
import styles from './atualizarInformacoes.module.scss';
import { formatCurrency } from '../../../../utils/formatCurrency';

interface IAtualizarInformacoesProps {
  onClickFunction: () => void;
  info: { label: string; value: number | string | null; precoUtilizado?: string; format?: Function }[];
  widthFitContent?: boolean;
  isLoading: boolean;
}

const AtualizarInformacoes = ({
  onClickFunction,
  info,
  widthFitContent = false,
  isLoading,
}: IAtualizarInformacoesProps) => {
  const containerClassName = widthFitContent ? styles.containerFitContent : styles.container;
  return (
    <div className={containerClassName}>
      <div className={styles.buttonContainer}>
        <BrButton block size='small' primary icon='fas fa-redo fa-sm' onClick={onClickFunction}>
          Atualizar Informações
        </BrButton>
      </div>
      <div className={styles.infoContainer}>
        {isLoading ? (
          <div className={styles.loadingContainer}>
            <BrLoading />
          </div>
        ) : (
          <>
            {info.map((item) => (
              <div key={item.label} className={styles.infoItem}>
                <span className={styles.label}>{item.label}:</span>
                <span>
                  {item.precoUtilizado ? item.precoUtilizado : ''}
                  {item.format ? item.format(item.value) : formatCurrency(item.value ? item.value : 0)}
                </span>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
};

export default AtualizarInformacoes;
